import APIService from '@/services/APIService.js';

export default {
  getAll(includeExpiredRecords) {
    return APIService.apiCall().get(`/racionalizacoesCom/getAll/${includeExpiredRecords}`);
  },
  getById(id) {
    return APIService.apiCall().get(`/racionalizacoesCom/getById/${id}`);
  },
  salvar(id, postData) {
    return APIService.apiCall().post(`/racionalizacoesCom/salvar/${id || ''}`, JSON.stringify(postData));
  },
  executar(id) {
    return APIService.apiCall().get(`/racionalizacoesCom/executar/${id}`);
  },
  deletar(id) {
    return APIService.apiCall().get(`/racionalizacoesCom/excluir/${id}`);
  },
  duplicar(id) {
    return APIService.apiCall().get(`/racionalizacoesCom/duplicar/${id}`);
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/racionalizacoesCom/baixarPlanilha/${id}`, { responseType: 'blob', ...config });
  },
  downloadLogs(id, config = {}) {
    return APIService.apiCall().get(`/racionalizacoesCom/downloadLogs/${id}`, { responseType: 'blob', ...config });
  },
  baixarLogsTecnicos(id, config = {}) {
    return this.downloadLogs(id, config);
  },
  andamento(id) {
    return APIService.apiCall().get(`/racionalizacoesCom/andamento/${id}`);
  }
};
